// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"Modal_pageHolder__2t6Km","modal":"Modal_modal__26D7a"};